import React, { useState, useEffect } from 'react';
import moment from "moment";
import Select from 'react-select';

const TimeSelect = ({selectedTime, startTime, endTime, interval, period, handleChange}) => {
  const [timeOptions, setTimeOptions] = useState([]);

  useEffect(() => {
    const options = getTimeOptions();
    setTimeOptions(options);
  }, []);

  const getTimeOptions = () => {
    const allTimes = [];

    const periodsInADay = moment.duration(1, 'day').as(period);
    const startTimeMoment = moment(startTime, 'hh:mm');
    const endTimeMoment = moment(endTime, 'hh:mm');

    for (let i = 0; i <= periodsInADay; i += interval) {
      startTimeMoment.add(i === 0 ? 0 : interval, period);
      if (startTimeMoment <= endTimeMoment) {
        allTimes.push({
          value: startTimeMoment.format('HH:mm:ss'),
          label: startTimeMoment.format('hh:mm A')
        });
      }
    }

    return allTimes;
  };

  return (
    timeOptions && <Select
      onChange={(obj) => {
        handleChange(obj.value);
      }}
      value={timeOptions.filter(item => item.value === selectedTime)}
      getOptionLabel={(a) => a.label}
      getOptionValue={(a) => a.value}
      options={timeOptions}
    />
  );
};

export default TimeSelect;